import { render, staticRenderFns } from "./ComponentInformation.vue?vue&type=template&id=615d5f16&"
import script from "./ComponentInformation.vue?vue&type=script&lang=js&"
export * from "./ComponentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615d5f16')) {
      api.createRecord('615d5f16', component.options)
    } else {
      api.reload('615d5f16', component.options)
    }
    module.hot.accept("./ComponentInformation.vue?vue&type=template&id=615d5f16&", function () {
      api.rerender('615d5f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/ComponentInformation.vue"
export default component.exports